import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  UserEntersBirthDay,
  userEntersBirthDay,
  UserEntersBirthMonth,
  userEntersBirthMonth,
  userEntersBirthYear,
  UserEntersBirthYear,
  userEntersEmail,
  userEntersFirstName,
  UserEntersFirstName,
  userEntersLastName,
  UserEntersLastName,
  UserEntersPhoneNumber,
  userEntersPhoneNumber
} from '../actions/Actions';
import { IState, IUserInfo } from '../CustomTypes';

export interface IActionProps {
  userEntersBirthDay: UserEntersBirthDay;
  userEntersBirthMonth: UserEntersBirthMonth;
  userEntersBirthYear: UserEntersBirthYear;
  userEntersPhoneNumber: UserEntersPhoneNumber;
  userEntersEmail: userEntersEmail;
  userEntersFirstName: UserEntersFirstName;
  userEntersLastName: UserEntersLastName;
}

export interface IStateProps {
  emailFromUrl: string;
  phoneNumberFromUrl: string;
  userInfo: IUserInfo;
  birthDayFromUrl: string;
  birthMonthFromUrl: string;
  birthYearFromUrl: string;
  firstNameFromUrl: string;
  lastNameFromUrl: string;
}

export interface IProps extends IStateProps, IActionProps {}

export class LoadUserDataFromUrl extends React.Component<IProps> {
  public componentWillMount() {
    const { email, firstName, lastName, phoneNumber } = this.props.userInfo;
    const {
      birthDayFromUrl,
      birthMonthFromUrl,
      birthYearFromUrl,
      emailFromUrl,
      firstNameFromUrl,
      lastNameFromUrl,
      phoneNumberFromUrl
    } = this.props;
    if (!email && emailFromUrl) {
      this.props.userEntersEmail(decodeURIComponent(emailFromUrl));
    }
    if (!phoneNumber && phoneNumberFromUrl) {
      this.props.userEntersPhoneNumber(decodeURIComponent(phoneNumberFromUrl));
    }
    if (!this.props.userInfo.birthDay && birthDayFromUrl) {
      this.props.userEntersBirthDay(birthDayFromUrl);
      this.props.userEntersBirthMonth(birthMonthFromUrl);
      this.props.userEntersBirthYear(birthYearFromUrl);
    }
    if (!firstName && firstNameFromUrl) {
      this.props.userEntersFirstName(decodeURIComponent(firstNameFromUrl));
    }
    if (!lastName && lastNameFromUrl) {
      this.props.userEntersLastName(decodeURIComponent(lastNameFromUrl));
    }
  }

  public render() {
    return <div />;
  }
}

export default connect(
  (state: IState) =>
    ({
      birthDayFromUrl: state.router.location.query.birthDay,
      birthMonthFromUrl: state.router.location.query.birthMonth,
      birthYearFromUrl: state.router.location.query.birthYear,
      emailFromUrl: state.router.location.query.email,
      firstNameFromUrl: state.router.location.query.firstName,
      lastNameFromUrl: state.router.location.query.lastName,
      phoneNumberFromUrl: state.router.location.query.phoneNumber,
      userInfo: state.userInfo
    } as IStateProps),
  dispatch =>
    bindActionCreators(
      {
        userEntersBirthDay,
        userEntersBirthMonth,
        userEntersBirthYear,
        userEntersEmail,
        userEntersFirstName,
        userEntersLastName,
        userEntersPhoneNumber
      },
      dispatch
    ) as IActionProps
)(LoadUserDataFromUrl);



// WEBPACK FOOTER //
// ./src/input-components/LoadUserDataFromUrl.tsx